import PwaRedirect from './pwa-redirect'

export { PwaRedirect }
